export default "__VITE_ASSET__6f63a274__"